import { Injectable } from '@angular/core';
import { SessionStorageService } from './session-storage';
import { CalAngularService } from '@cvx/cal-angular';
import { BehaviorSubject, Subject } from 'rxjs';
import { UserDetails } from '../interface/user';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  loggedUserDetails = new BehaviorSubject<UserDetails[]>([]);
  private msgSource = new Subject<string>();
  getFacilityId = this.msgSource.asObservable();

  constructor(
    private session: SessionStorageService,
    private authService: CalAngularService
  ) {}

  getAccessToken() {
    this.authService.getAADToken().subscribe((result) => {
      this.session.setItem('token', JSON.parse(JSON.stringify(result)));
      while (this.session.getItem('token') === undefined) {
        this.session.setItem('token', JSON.parse(JSON.stringify(result)));
      }
    });
  }

  getUserDetail(value: UserDetails[]) {
    this.loggedUserDetails.next(value);
  }

  updateFacility(fac_id: string) {
    let value = this.session.getItem('userAccess');
    if (value) {
      value.faC_ID = fac_id;
      this.session.setItem('userAccess', JSON.parse(JSON.stringify(value)));
    }

    this.msgSource.next(fac_id);
  }
}
